import React from 'react';
import { Link } from 'react-router-dom';
import { CellRendererProps } from '../../types';
import { formatCellValue } from '../../utils';

export const CellRenderer: React.FC<CellRendererProps> = ({
  value,
  column,
  row
}) => {
  // Cast column.type since our types are compatible
  const columnType = column.type;
  const formattedValue = formatCellValue(value, columnType);

  // Check if this column has a link
  const links = row._links;
  if (links && links[column.id]) {
    const linkPath = links[column.id];
    return <Link to={String(linkPath)}>{formattedValue}</Link>;
  }

  return <span>{formattedValue}</span>;
};

export default React.memo(CellRenderer);
